var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("vue-treeselect__tip vue-treeselect__" + _vm.type + "-tip")},[_c('div',{staticClass:"vue-treeselect__icon-container"},[_c('span',{class:("vue-treeselect__icon-" + _vm.icon)})]),_vm._v(" "),_c('span',{class:("vue-treeselect__tip-text vue-treeselect__" + _vm.type + "-tip-text")},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/tree-select/Tip.vue